export default {
  lang_name: 'Deutsch',
  tab_main: 'Haupt', tab_upgrade: 'Upgrade', tab_prestige: 'Prestige', tab_achievement: 'Erfolge', tab_mission: 'Mission', tab_domination: 'Welt', tab_settings: 'Einst.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: 'TIPPEN!', main_combo: 'Kombo',
  prod_informant: 'Informant', prod_informant_desc: 'Informationsbeschaffung',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Netzwerk-Infiltration',
  prod_disguiser: 'Verkleidung', prod_disguiser_desc: 'Menschliche Tarnung',
  prod_mindController: 'Gedankenkontrolle', prod_mindController_desc: 'Meinungsmanipulation',
  prod_secretLab: 'Geheimlabor', prod_secretLab_desc: 'Reptilien-Technologie',
  prod_mediaCell: 'Medienzelle', prod_mediaCell_desc: 'Nachrichtensteuerung',
  prod_shadowGovt: 'Schattenregierung', prod_shadowGovt_desc: 'Politikerersatz',
  prod_deepBase: 'Tiefe Basis', prod_deepBase_desc: 'Untergrund-Megabasis',
  prod_orbitalStation: 'Orbitalstation', prod_orbitalStation_desc: 'Satellitenüberwachung',
  prod_dimensionGate: 'Dimensionstor', prod_dimensionGate_desc: 'Heimatwelt-Verstärkung',
  prod_planetController: 'Planetenkontrolle', prod_planetController_desc: 'Erdkontrolle',
  prod_galacticBeacon: 'Galaktischer Sender', prod_galacticBeacon_desc: 'Direktleitung zum HQ',
  prod_locked: 'Freischalten: ', prod_locked_prestige: 'Prestige {n}x', prod_locked_time: '{n}min Spiel',
  milestone_squad: 'Trupp', milestone_company: 'Kompanie', milestone_battalion: 'Bataillon',
  milestone_regiment: 'Regiment', milestone_division: 'Division', milestone_corps: 'Korps',
  click_basic_training: 'Grundausbildung', click_combat_training: 'Kampftraining',
  click_psychic_awaken: 'Psychisches Erwachen', click_transform: 'Transformation',
  click_telepathy: 'Telepathie', click_critical_eye: 'Kritisches Auge',
  click_dimension_sense: 'Dimensionssinn', click_galaxy_field: 'Galaxiefeld',
  click_lethal_strike: 'Tödlicher Schlag', click_absolute: 'Absolute Infiltration',
  click_planet_destroyer: 'Planetenzerstörer', click_galaxy_finger: 'Finger des Overlords',
  special_info_network: 'Info-Netzwerk', special_info_network_desc: 'Informant & Hacker x2',
  special_perfect_disguise: 'Perfekte Tarnung', special_perfect_disguise_desc: 'Alle Agenten x1.5',
  special_mass_brainwash: 'Massengehirnwäsche', special_mass_brainwash_desc: 'Gedankenkontrolle & Medien x3',
  special_shadow_network: 'Schattennetzwerk', special_shadow_network_desc: 'Offline-Einkommen +25%',
  special_underground_empire: 'Untergrundimperium', special_underground_empire_desc: 'Alle Agenten x2',
  special_orbital_surveillance: 'Orbitalüberwachung', special_orbital_surveillance_desc: 'Goldene Events +50%',
  special_dimension_supply: 'Dimensionsversorgung', special_dimension_supply_desc: 'Tipp-Einkommen x5',
  special_galactic_alliance: 'Galaktische Allianz', special_galactic_alliance_desc: '🛸 pro Sekunde x10',
  special_combo_master: 'Kombo-Meister', special_combo_master_desc: 'Kombo-Limit x3',
  special_time_warp: 'Zeitsprung', special_time_warp_desc: 'Offline-Limit 12h',
  special_agent_synergy: 'Agentensynergie', special_agent_synergy_desc: '🛸 pro Sekunde x1.5',
  special_massive_infiltration: 'Masseninfiltration', special_massive_infiltration_desc: '🛸 pro Sekunde x2',
  subtab_click: 'Klick', subtab_special: 'Spezial',
  prestige_title: 'Umstrukturierung', prestige_total_ip: 'Gesamt-🛸', prestige_gc_gain: '💎-Gewinn',
  prestige_gc_current: 'Aktuelle 💎', prestige_execute: 'Umstrukturieren',
  prestige_confirm: 'Fortschritt zurücksetzen für {gc} Galaktische Credits?',
  prestige_ad_bonus: 'Werbung für +50% 💎', prestige_requirement: '10B+ 🛸 für Prestige nötig',
  prestige2_title: 'Galaxie-Umstrukturierung', prestige2_cores_gain: '🔮 erhalten',
  prestige2_cores_current: 'Aktuelle 🔮', prestige2_execute: 'Galaxie-Umstrukturierung',
  prestige2_requirement: '15+ Prestiges & 100+ 💎 nötig',
  prestige2_confirm: 'Alles zurücksetzen für {cores} Galaxie-Kerne?',
  pup_galaxy_mult: 'Galaxie-Multiplikator', pup_galaxy_mult_desc: 'CPS x1.5 pro Level (multiplikativ stapelbar)',
  pup_infil_accel: 'Infiltrations-Beschleunigung', pup_infil_accel_desc: 'Nach Prestige pro Level mit 100M 🛸 starten',
  pup_tap_enhance: 'Tipp-Verstärkung', pup_tap_enhance_desc: 'Tipp-Einkommen x2 pro Level (multiplikativ stapelbar)',
  pup_offline_expand: 'Offline-Erweiterung', pup_offline_expand_desc: 'Offline-Belohnungs-Limit +1h/Lv (Basis 8h)',
  pup_offline_eff: 'Offline-Effizienz', pup_offline_eff_desc: 'Offline-Einkommensrate +10%p/Lv (Basis 50%)',
  pup_agent_discount: 'Agentenrabatt', pup_agent_discount_desc: 'Agenten-Einstellungskosten -10% pro Level (max -50%)',
  pup_auto_click: 'Auto-Klick', pup_auto_click_desc: 'Auto-Tipp 3x/Sek pro Level (max 15/Sek)',
  pup_golden_luck: 'Goldenes Glück', pup_golden_luck_desc: 'Goldenes Event Belohnung +20%/Lv (max +200%)',
  pup_combo_keep: 'Kombo-Erhalt', pup_combo_keep_desc: 'Combo-Timer +0.5s/Lv (Basis 2s)',
  pup_quick_start: 'Schnellstart', pup_quick_start_desc: 'Nach Prestige je 1 der ersten 5 Agenten automatisch erhalten',
  p2up_galaxy_speed: 'Galaxie-Geschwindigkeit', p2up_galaxy_speed_desc: '💎-Gewinn x2 pro Level bei Prestige (multiplikativ)',
  p2up_auto_prestige: 'Auto-Prestige', p2up_auto_prestige_desc: 'Automatisches Prestige bei 10Mrd 🛸',
  p2up_permanent: 'Permanente Agenten', p2up_permanent_desc: 'Erste 3 Agententypen nach Prestige behalten',
  p2up_dimension_accel: 'Dimensions-Beschleunigung', p2up_dimension_accel_desc: 'CPS x5 pro Level (stapelbar, permanent)',
  p2up_galaxy_memory: 'Galaxie-Gedächtnis', p2up_galaxy_memory_desc: '3 aktive Boosts durch Prestige behalten',
  p2up_spacetime: 'Raumzeitkrümmung', p2up_spacetime_desc: 'Offline-Einkommensrate auf 100% setzen (permanent)',
  p2up_automate: 'Galaxie-Automatisierung', p2up_automate_desc: 'Agenten automatisch einstellen (permanent)',
  rank_e: 'Praktikant', rank_d: 'Junior-Agent', rank_c: 'Agent', rank_b: 'Senior-Agent',
  rank_a: 'Direktor', rank_s: 'Kommandant', rank_ss: 'Oberbefehlshaber', rank_sss: 'Galaktischer Overlord',
  ach_title: 'Erfolge', ach_filter_all: 'Alle', ach_filter_tap: 'Tippen', ach_filter_resource: 'Ressource',
  ach_filter_producer: 'Produzent', ach_filter_prestige: 'Prestige', ach_filter_time: 'Zeit',
  ach_filter_special: 'Spezial', ach_filter_ad: 'Dokumente', ach_filter_combo: 'Kombo',
  ach_t01: 'Erster Schritt', ach_t01_reward: '+1 Tippkraft', ach_t02: 'Fingerübung', ach_t02_reward: '+5% Tippkraft',
  ach_t03: 'Beständiger Agent', ach_t03_reward: '+10% Tippkraft', ach_t04: 'Touch-Meister', ach_t04_reward: '+15% Tippkraft',
  ach_t05: 'Reptilischer Biss', ach_t05_reward: '+20% Tippkraft', ach_t06: 'Galaxiefinger', ach_t06_reward: '+25% Tippkraft',
  ach_t07: 'Kombo-Lehrling', ach_t07_reward: '+0.5s Kombo', ach_t08: 'Kombo-Meister', ach_t08_reward: '+0.5 Kombo-Limit',
  ach_r01: 'Kleine Info', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Info-Sammler', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Geheimtresor', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Millionen-Infiltration', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Milliarden-Agent', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Billionen-Ops', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Billiarden-Imperium', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Galaxie-Ozean', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Kosmisches Universum', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Unendliche Infiltration', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Erste Rekrutierung', ach_g01_reward: 'Informant x1.5', ach_g02: 'Intel-Netzwerk', ach_g02_reward: 'Informant x2',
  ach_g03: 'Hacking beginnt', ach_g03_reward: 'Hacker x2', ach_g04: 'Cyber-Legion', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Meister der Tarnung', ach_g05_reward: 'Verkleidung x2', ach_g06: 'Gehirnwäsche-Netz', ach_g06_reward: 'Gedankenkontrolle x2',
  ach_g07: 'Verrückte Wissenschaft', ach_g07_reward: 'Geheimlabor x2', ach_g08: 'Medienkontrolle', ach_g08_reward: 'Medienzelle x2',
  ach_g09: 'Schattenkabinett', ach_g09_reward: 'Schattenregierung x2', ach_g10: 'Untergrundimperium', ach_g10_reward: 'Tiefe Basis x2',
  ach_g11: 'Orbitale Dominanz', ach_g11_reward: 'Orbitalstation x2', ach_g12: 'Meister der Galaxie', ach_g12_reward: 'Gesamt \u{1F6F8}/s x2',
  ach_p01: 'Erste Umstrukturierung', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Geschmack des Zyklus', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veteran', ach_p03_reward: '+10% 💎', ach_p04: 'Prestige-Süchtiger', ach_p04_reward: '+15% 💎',
  ach_p05: 'Endlosschleife', ach_p05_reward: '+20% 💎', ach_p06: 'Galaxie-Gedächtnis', ach_p06_reward: '+25% 💎',
  ach_p07: 'Galaxie-Umstrukturierung', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Dimensionsherrscher', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Neuling', ach_h01_reward: 'Willkommensbonus 100 🛸', ach_h02: '1-Stunden-Schicht', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Halber Tag', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: '24h Überwachung', ach_h04_reward: 'Offline +2h',
  ach_h05: '3-Tage-Mission', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Wocheninfiltration', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Verdächtiger Mensch', ach_s01_reward: '1 Dok', ach_s02: 'Neustart', ach_s02_reward: 'Titel: Waghalsiger Agent',
  ach_s03: 'Alles rein', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Goldjäger', ach_s05_reward: 'Event-Frequenz -20%', ach_s06: 'Nachtagent', ach_s06_reward: 'Nacht \u{1F6F8}/s x1.5',
  ach_s07: 'F2P-Krieger', ach_s07_reward: 'Werbebelohnung +30%', ach_s08: 'Sammler', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Werbeanfänger', ach_a01_reward: '1 Dok', ach_a02: 'Werbebegeistert', ach_a02_reward: '2 Doks',
  ach_a03: 'Werbemeister', ach_a03_reward: 'Werbebelohnung +30%', ach_a04: 'Dok-Sammler', ach_a04_reward: 'Dok-Effekt +20%',
  ach_a05: 'Dok-Experte', ach_a05_reward: 'Dok-Effekt +50%',
  ach_c01: 'Kombo-Start', ach_c01_reward: '+0.3s Kombo', ach_c02: 'Im Rhythmus', ach_c02_reward: '+0.1 Kombo-Mult',
  ach_c03: 'Goldener Anfänger', ach_c03_reward: 'Event-Belohnung +10%', ach_c04: 'Goldener Sammler', ach_c04_reward: 'Event-Frequenz -10%',
  ach_c05: 'Täglicher Wahnsinn', ach_c05_reward: 'Missionsbelohnung +50%',
  golden_intel_leak: 'Info-Leak!', golden_agent_frenzy: 'Agenten-Rausch!', golden_money_launder: 'Geldwäsche!',
  golden_facility_boost: 'Anlagen-Overdrive!', golden_supply_drop: 'Galaxie-Lieferung!', golden_touch: 'TIPPEN!',
  golden_ad_double: 'Werbung für 2x',
  offline_title: 'Abwesenheitsbericht', offline_elapsed: 'Vergangene Zeit', offline_earned: 'Verdiente 🛸',
  offline_cap: 'Max {h}h angewendet', offline_claim: 'Einsammeln', offline_double: 'Werbung für 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Einstellungen', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Sprache',
  settings_reset: 'Spiel zurücksetzen', settings_reset_confirm: 'ALLEN Fortschritt löschen?',
  settings_stats: 'Statistiken', settings_total_ip: 'Gesamt-🛸', settings_total_taps: 'Gesamt-Tipps',
  settings_total_prestiges: 'Gesamt-Prestiges', settings_play_time: 'Gesamtspielzeit', settings_docs_shop: 'Geheimakten-Shop',
  doc_shop_title: 'Geheimakten-Shop',
  doc_ip_boost: 'Einkommens-Beschleuniger', doc_ip_boost_desc: '2x 🛸/s Produktion fur 30 Sek',
  doc_mega_tap: 'Power-Tipp-Training', doc_mega_tap_desc: '3x Tipp-Einkommen fur 30 Sek',
  doc_auto_click: 'Auto-Infiltrator', doc_auto_click_desc: 'Auto-Tipp 10x/Sek fur 30 Sek',
  doc_instant_golden: 'Goldener Notruf', doc_instant_golden_desc: 'Goldenes Event sofort auslosen',
  doc_timeskip: 'Zeitbeschleuniger', doc_timeskip_desc: '2 Std 🛸-Einkommen sofort erhalten',
  doc_prestige_boost: 'Galaxis-Verstarker', doc_prestige_boost_desc: '2x 💎 beim nachsten Prestige',
  doc_prestige_boost_active: '💎 x2 wartet auf nachstes Prestige', doc_prestige_boost_active_badge: '✅ Aktiv',
  ad_offline_double: 'Doppelte Offline-Belohnung', ad_cps_boost: 'Einkommen/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestige +50% 💎', ad_timeskip: 'Zeitsprung (2h)', ad_free_docs: 'Gratis Geheimakten',
  ad_golden_double: 'Doppelte goldene Belohnung', ad_start_boost: 'Startboost-Paket',
  ad_watching: 'Werbung wird geladen...', ad_cooldown: 'Verfügbar in {t}',
  settings_sfx_test: 'SFX testen', settings_sound_reset: 'Zurücksetzen', settings_sound_reset_done: 'Sound zurückgesetzt',
  num_k: 'K', num_m: 'M', num_b: 'Mrd', num_t: 'Bio', num_qa: 'Brd', num_qi: 'Tri', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Tagesmissionen',
  mission_claim: 'Abholen',
  mission_all_complete: 'Alle abgeschlossen Bonus!',
  mission_clear_label: 'MISSION',
  mission_all_clear_label: 'ALLE KLAR',
  ach_unlock_label: 'ERFOLG',
  mission_diff_easy: 'Leicht',
  mission_diff_normal: 'Mittel',
  mission_diff_hard: 'Schwer',
  mission_tap_100: 'Leichte Berührung', mission_tap_100_desc: '100 Mal tippen',
  mission_tap_300: 'Warme Hände', mission_tap_300_desc: '300 Mal tippen',
  mission_buy_5: 'Kleine Rekrutierung', mission_buy_5_desc: '5 Produzenten kaufen',
  mission_combo_10: 'Kombo-Starter', mission_combo_10_desc: '10 Kombo erreichen',
  mission_golden_1: 'Glücksfang', mission_golden_1_desc: '1 goldenes Event fangen',
  mission_tap_1000: 'Harter Schlag', mission_tap_1000_desc: '1.000 Mal tippen',
  mission_buy_20: 'Truppaufbau', mission_buy_20_desc: '20 Produzenten kaufen',
  mission_combo_50: 'Kombo-Profi', mission_combo_50_desc: '50 Kombo erreichen',
  mission_golden_3: 'Goldrausch', mission_golden_3_desc: '3 goldene Events fangen',
  mission_earn_1m: 'Millionen-Ops', mission_earn_1m_desc: '1M 🛸 verdienen',
  mission_tap_5000: 'Tipp-Maschine', mission_tap_5000_desc: '5.000 Mal tippen',
  mission_buy_50: 'Armee-Aufbau', mission_buy_50_desc: '50 Produzenten kaufen',
  mission_combo_100: 'Kombo-Gott', mission_combo_100_desc: '100 Kombo erreichen',
  mission_golden_5: 'Goldener Meister', mission_golden_5_desc: '5 goldene Events fangen',
  mission_earn_1b: 'Milliarden-Agent', mission_earn_1b_desc: '1Mrd 🛸 verdienen',
  mission_tap_200: 'Schnelle Finger',
  mission_tap_200_desc: '200 Mal tippen',
  mission_buy_3: 'Erste Rekruten',
  mission_buy_3_desc: '3 Produzenten kaufen',
  mission_combo_15: 'Combo-Anfänger',
  mission_combo_15_desc: '15er Combo erreichen',
  mission_earn_10k: 'Taschengeld',
  mission_earn_10k_desc: '10K 🛸 verdienen',
  mission_earn_100k: 'Spendensammler',
  mission_earn_100k_desc: '100K 🛸 verdienen',
  mission_tap_500: 'Beständiger Tipper',
  mission_tap_500_desc: '500 Mal tippen',
  mission_tap_700: 'Unerbittlich',
  mission_tap_700_desc: '700 Mal tippen',
  mission_buy_10: 'Teamleiter',
  mission_buy_10_desc: '10 Produzenten kaufen',
  mission_combo_30: 'Combo-Kette',
  mission_combo_30_desc: '30er Combo erreichen',
  mission_golden_2: 'Doppelgold',
  mission_golden_2_desc: '2 goldene Events fangen',
  mission_tap_3000: 'Tipp-Krieger',
  mission_tap_3000_desc: '3.000 Mal tippen',
  mission_buy_30: 'Bataillon',
  mission_buy_30_desc: '30 Produzenten kaufen',
  mission_combo_75: 'Combo-Elite',
  mission_combo_75_desc: '75er Combo erreichen',
  mission_golden_4: 'Goldjäger',
  mission_golden_4_desc: '4 goldene Events fangen',
  mission_earn_10m: 'Tycoon',
  mission_earn_10m_desc: '10M 🛸 verdienen',
  // Conquest
  cq_title: 'Welteroberung',
  cq_progress: 'Erobert',
  cq_infiltration_power: 'Infiltrationskraft',
  cq_active_conquest: 'Infiltriert',
  cq_infiltration_progress: 'Infiltrationsfortschritt',
  cq_time_remaining: 'Geschätzte Zeit',
  cq_start_infiltration: 'Infiltration starten',
  cq_stop_infiltration: 'Infiltration stoppen',
  cq_no_power_hint: 'Stellen Sie Agenten ein, um Infiltrationskraft zu erzeugen',
  cq_locked: 'Gesperrt',
  cq_available: 'Verfügbar',
  cq_conquered: 'Erobert',
  cq_popup_title: 'Eroberung abgeschlossen!',
  cq_popup_desc: 'wurde erobert! Baue Einrichtungen, um stärker zu werden.',
  cq_back: 'Zurück',
  cq_invest_title: '🛸 investieren um zu erobern',
  cq_current_ip: 'Aktuell 🛸',
  cq_facilities: 'Einrichtungen',
  cq_build: 'Bauen',
  cq_upgrade: 'Verbessern',
  cq_next_level: 'Nächste',
  cq_counter_intel_title: 'Spionageabwehr-Alarm!',
  cq_counter_intel_text: 'Ihre Infiltration in {country} wurde entdeckt! Fortschritt wird reduziert.',
  cq_defend_ad: 'Werbung sehen & verteidigen',
  cq_accept_loss: 'Verlust akzeptieren',
  cq_ending_title: 'Erde erobert!',
  cq_ending_text: 'Die Reptilien-Verschwörung ist vollständig. Alle Nationen beugen sich dem Schattenreich.',
  cq_ending_time: 'Spielzeit',
  cq_ending_prestiges: 'Prestiges',
  cq_ending_total_ip: 'Gesamt-🛸',
  cq_ending_taps: 'Gesamt-Taps',
  cq_ending_continue: 'Weiterspielen',
  cq_egypt: 'Ägypten', cq_egypt_desc: 'Antike Pyramidenbasen',
  cq_brazil: 'Brasilien', cq_brazil_desc: 'Amazonas-Dschungelverstecke',
  cq_india: 'Indien', cq_india_desc: 'Naga-Kult-Infiltration',
  cq_australia: 'Australien', cq_australia_desc: 'Wüsten-Untergrundbunker',
  cq_japan: 'Japan', cq_japan_desc: 'Technologie-Diebstahl',
  cq_korea: 'Korea', cq_korea_desc: 'NIS Cyber-Abwehr-Durchbruch',
  cq_uk: 'Vereinigtes Königreich', cq_uk_desc: 'MI5/MI6 Königliche Infiltration',
  cq_russia: 'Russland', cq_russia_desc: 'FSB Sibirische Operationen',
  cq_china: 'China', cq_china_desc: 'Stärkste Überwachung der Welt',
  cq_usa: 'Vereinigte Staaten', cq_usa_desc: 'CIA/NSA Endboss',
  fac_pyramid_vault: 'Pyramiden-Tresor', fac_pyramid_vault_d: '\u{1F6F8}/s +5% pro Level',
  fac_nile_network: 'Nil-Netzwerk', fac_nile_network_d: 'Offline +5% pro Level',
  fac_ancient_lab: 'Antikes Labor', fac_ancient_lab_d: 'TAP +10% pro Level',
  fac_amazon_hideout: 'Amazonas-Versteck', fac_amazon_hideout_d: 'Produzenten-Rabatt +2% pro Level',
  fac_samba_broadcast: 'Samba-Sender', fac_samba_broadcast_d: '\u{1F6F8}/s +8% pro Level',
  fac_jungle_lab: 'Dschungel-Labor', fac_jungle_lab_d: 'Golden Event +5% pro Level',
  fac_naga_temple: 'Naga-Tempel', fac_naga_temple_d: '💎 +5% pro Level',
  fac_bollywood_studio: 'Bollywood-Studio', fac_bollywood_studio_d: 'Offline +8% pro Level',
  fac_caste_network: 'Kasten-Netzwerk', fac_caste_network_d: '\u{1F6F8}/s +12% pro Level',
  fac_desert_bunker: 'Wüsten-Bunker', fac_desert_bunker_d: 'TAP +15% pro Level',
  fac_ayers_signal: 'Ayers-Signal', fac_ayers_signal_d: 'Golden Event +8% pro Level',
  fac_outback_base: 'Outback-Basis', fac_outback_base_d: '\u{1F6F8}/s +15% pro Level',
  fac_akiba_ai: 'Akihabara-KI', fac_akiba_ai_d: '\u{1F6F8}/s +20% pro Level',
  fac_ninja_intel: 'Ninja-Nachricht', fac_ninja_intel_d: 'Produzenten-Rabatt +3% pro Level',
  fac_tokyo_tower: 'Tokio-Turm', fac_tokyo_tower_d: '💎 +8% pro Level',
  fac_gangnam_hq: 'Gangnam-HQ', fac_gangnam_hq_d: '\u{1F6F8}/s +25% pro Level',
  fac_cyber_command: 'Cyber-Kommando', fac_cyber_command_d: 'TAP +25% pro Level',
  fac_kpop_brainwash: 'K-Pop Gehirnwäsche', fac_kpop_brainwash_d: '💎 +10% pro Level',
  fac_royal_infiltrate: 'Königliche Infiltration', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% pro Level',
  fac_london_tower: 'London Tower', fac_london_tower_d: 'Offline +15% pro Level',
  fac_mi6_double: 'MI6 Doppelagent', fac_mi6_double_d: 'Golden Event +12% pro Level',
  fac_siberia_base: 'Sibirien-Basis', fac_siberia_base_d: '\u{1F6F8}/s +40% pro Level',
  fac_kgb_remnant: 'KGB-Überbleibsel', fac_kgb_remnant_d: 'Produzenten-Rabatt +5% pro Level',
  fac_nuke_bunker: 'Atom-Bunker', fac_nuke_bunker_d: 'TAP +40% pro Level',
  fac_great_wall: 'Große Firewall', fac_great_wall_d: '\u{1F6F8}/s +50% pro Level',
  fac_shenzhen_factory: 'Shenzhen-Fabrik', fac_shenzhen_factory_d: 'Produzenten-Rabatt +8% pro Level',
  fac_panda_spy: 'Panda-Spionagering', fac_panda_spy_d: 'Golden Event +20% pro Level',
  fac_area51: 'Area 51', fac_area51_d: '\u{1F6F8}/s +80% pro Level',
  fac_pentagon: 'Pentagon', fac_pentagon_d: 'TAP +80% pro Level',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% pro Level',

  buy: 'Kaufen', max: 'MAX', level: 'Lv.', locked: 'Gesperrt', unlocked: 'Freigeschaltet',
  upgrade_locked_prev: 'Vorheriges Upgrade zuerst erlernen',
  condition: 'Bedingung', cost: 'Kosten', owned: 'Besitz', effect: 'Effekt', reward: 'Belohnung',
  close: 'Schließen', confirm: 'Bestätigen', cancel: 'Abbrechen',

  // Conquest achievements
  ach_filter_conquest: 'Eroberung',
  ach_q01: 'Erste Eroberung', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Dreifache Bedrohung', ach_q02_reward: 'TAP +10%',
  ach_q03: 'Halbe Welt', ach_q03_reward: '💎 +15%',
  ach_q04: 'Sieben Flaggen', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Weltherrscher', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Anlagenmeister', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Nächstes',
  settings_conquest: 'Eroberung',

  // Currency info
  currency_ip_name: 'Infiltrationspunkte (IP)',
  currency_ip_earn: 'Durch Tippen, Auto-Produktion, Offline-Einkommen und Werbung',
  currency_ip_use: 'Agenten anheuern, Upgrades kaufen, in Eroberung investieren',
  currency_gc_name: 'Galaktische Credits (GC)',
  currency_gc_earn: 'Beim Prestige (Reorganisation) basierend auf Gesamt-IP',
  currency_gc_use: 'Prestige-Upgrades kaufen (Produktionsmultiplikator, Offline-Effizienz usw.)',
  currency_cores_name: 'Galaxie-Kerne',
  currency_cores_earn: 'Beim 2. Prestige (Galaxie-Reorganisation) basierend auf Gesamt-GC',
  currency_cores_use: '2. Prestige-Upgrades kaufen (permanente Buffs, Automatisierung usw.)',
  currency_docs_name: 'Geheimdokumente',
  currency_docs_earn: 'Tägliche Missionen, Werbung ansehen oder Erfolge freischalten',
  currency_docs_use: 'Im Dokument-Shop (Missions-Tab) starke Boosts kaufen',
  currency_how_earn: 'Wie verdienen',
  currency_how_use: 'Verwendung',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Infiltrationsmeister',
  pup_infiltration_mastery_desc: 'Gesamt-Infiltrationskraft +50%/Lv (max +500%)',
  pup_agent_network: 'Agentennetzwerk',
  pup_agent_network_desc: 'Pro 100 Agenten Infiltration +5% pro Level',
  pup_quick_infiltration: 'Ketteninfiltration',
  pup_quick_infiltration_desc: 'Bei Eroberung: nächstes Land +10% Fortschritt/Lv',
  pup_critical_chance: 'Kritisches Training',
  pup_critical_chance_desc: 'Tipp-Krit-Chance +3%/Lv (Basis 10%, max 50%)',
  pup_critical_damage: 'Kritische Kraft',
  pup_critical_damage_desc: 'Krit-Schaden +1x/Lv (Basis x3)',

  // Special upgrades - conquest
  special_spy_master: 'Spionagemeister',
  special_spy_master_desc: 'Gesamte Infiltrationskraft x2',

  ad_income_x5: '30min Einkommen',
  ad_income_x5_desc: 'Sieh dir eine Werbung an und erhalte\nsofort {amount} 🛸 (30 Minuten Einkommen)!',
  ad_tap_x10: 'Tippen x10 (10s)',
  ad_tap_x10_desc: 'Sieh dir eine Werbung an und\nverstärke das Tipp-Einkommen 10 Sekunden lang x10!',
  ad_free_docs_desc: 'Sieh dir eine Werbung an und\nerhalte 1 Geheimdokument 📜 kostenlos!',
  ad_prestige_desc: 'Sieh dir eine Werbung an und\nerhöhe dein Einkommen x10 für 15 Sekunden!',
  cq_tutorial_title: '🌍 Weltherrschaft-Anleitung',
  cq_tutorial_text: 'Nach der Eroberung eines Landes kannst du <b>Einrichtungen</b> bauen!\nUpgrade sie für permanente Boni wie\n<b>EPS, Tipp-Einkommen, Offline-Einkommen</b> und mehr.\n\nStelle Agenten ein, um die Infiltrationskraft zu erhöhen.',
  rank_promote: 'Befördern',
  rank_promoted: 'Beförderung abgeschlossen!',

  // Boss events
  boss_resistance_captain: 'Widerstandskapitän',
  boss_resistance_captain_desc: 'Anführer der menschlichen Miliz, erfahrener Kämpfer',
  boss_cia_agent: 'CIA-Agent',
  boss_cia_agent_desc: 'Verdeckter Ermittler mit geheimen Informationen',
  boss_mib_investigator: 'MIB-Ermittler',
  boss_mib_investigator_desc: 'Men In Black Außendienstagent',
  boss_un_inspector: 'UN-Inspektor',
  boss_un_inspector_desc: 'Internationaler Verschwörungsjäger',
  boss_whistleblower: 'Whistleblower',
  boss_whistleblower_desc: 'Abtrünniger Insider mit Beweisen',
  boss_journalist: 'Investigativ-Journalist',
  boss_journalist_desc: 'Unermüdlicher Wahrheitssucher mit Kamera',
  boss_truth_seeker: 'Wahrheitssucher',
  boss_truth_seeker_desc: 'Paranormaler Forscher auf der Spur',
  boss_galactic_guardian: 'Galaktischer Wächter',
  boss_galactic_guardian_desc: 'Kosmischer Vollstrecker des Universalrechts',

  boss_alert: 'BEDROHUNG ERKANNT!',
  boss_alert_desc: 'Ein Feind ist aufgetaucht! Tippen zum Angreifen!',
  boss_hp: 'HP',
  boss_tap_attack: 'TIPPEN ZUM ANGREIFEN!',
  boss_double_damage: '2x SCH (30s)',
  boss_eliminated: 'ELIMINIERT!',
  boss_eliminated_desc: '{name} wurde neutralisiert!',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}s)',
  boss_claim: 'Belohnung einfordern',
  boss_claim_double: '2x Belohnung',
  boss_escaped: 'ENTKOMMEN!',
  boss_escaped_desc: 'Das Ziel ist entkommen...',
  boss_revive: 'Erneut versuchen (+20s)',
  boss_phase2: 'RASEND!',
  boss_streak: 'Killserie: {n}',
  boss_time_remaining: 'Zeit',
  boss_double_damage_active: '2x SCH Aktiv!',

  // Agent collection
  tab_agent: 'Agenten',
  agent_collection_title: 'Agentensammlung',
  agent_equipped: 'Ausgerüstet',
  agent_empty_slot: 'Leer',
  agent_obtained: 'Agent erhalten!',
  agent_equip: 'Ausrüsten',
  agent_unequip: 'Ablegen',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: 'Agenten-Sammelhandbuch',
  agent_tutorial_text: 'Besiege <b>Bosse</b>, um Agentenkarten zu sammeln!<br><br>Jeder Agent hat einen einzigartigen passiven Bonus.<br>Tippe auf die Karte, um Agenten auszurusten.<br><br>Hohere Seltenheit = starkere Effekte.<br>Prestige schaltet mehr Ausrustungsplatze frei.',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: 'Eroberungstempo {n}',
  agent_effect_boss_damage: 'Boss-Schaden {n}',
  agent_effect_golden_chance: 'Goldenes Ereignis {n}',
  agent_effect_offline_pct: 'Offline-Einkommen {n}',
  agent_effect_docs_rate: 'Dok.-Rate {n}',
  agent_effect_gc_pct: 'GC-Gewinn {n}',
  agent_effect_boss_spawn_reduce: 'Boss-Erscheinen -{n}',
  agent_effect_prestige_gc_bonus: 'Prestige-GC {n}',
  agent_effect_faction_favor: 'Fraktionsgunst {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: 'Feldspion',
  agent_field_spy_desc: 'Feldaufklärung steigert IP-Produktion +8%',
  agent_code_cracker: 'Codeknacker',
  agent_code_cracker_desc: 'Entschlüsselungsfähigkeit steigert Tippkraft +10%',
  agent_shadow_runner: 'Schattenläufer',
  agent_shadow_runner_desc: 'Tarnexpertise beschleunigt Eroberung +10%',
  agent_data_miner: 'Datenschürfer',
  agent_data_miner_desc: 'Datensammlung steigert Offline-Einkommen +15%',
  agent_lookout: 'Ausguck',
  agent_lookout_desc: 'Scharfe Augen steigern Chance auf goldenes Ereignis +10%',
  agent_doc_thief: 'Dokumentendieb',
  agent_doc_thief_desc: 'Dokumentendiebstahl steigert Dok.-Erwerb +15%',
  agent_network_bot: 'Netzwerk-Bot',
  agent_network_bot_desc: 'Automatisierte Netzwerke steigern CPS +10%',
  agent_safe_cracker: 'Tresorknacker',
  agent_safe_cracker_desc: 'Tresorfähigkeit steigert Tippkraft +12%',
  agent_recruit: 'Rekrut',
  agent_recruit_desc: 'Neuer Kämpfer steigert Boss-Schaden +10%',
  agent_comm_officer: 'Kommunikationsoffizier',
  agent_comm_officer_desc: 'Kommunikation steigert Fraktionsgunst +10%',

  // Rare (8)
  agent_infiltration_ace: 'Infiltrations-Ass',
  agent_infiltration_ace_desc: 'Elite-Infiltrator steigert CPS +20%',
  agent_mind_bender: 'Gedankenbieger',
  agent_mind_bender_desc: 'Psychische Kräfte beschleunigen Eroberung +25%',
  agent_vault_raider: 'Tresorräuber',
  agent_vault_raider_desc: 'Tresorexpertise steigert GC-Gewinn +20%',
  agent_signal_jammer: 'Signalstörer',
  agent_signal_jammer_desc: 'Störung verringert Boss-Erscheinungsintervall -15%',
  agent_double_agent: 'Doppelagent',
  agent_double_agent_desc: 'Doppelte Loyalität steigert Offline-Einkommen +30%',
  agent_hive_mind: 'Schwarmintelligenz',
  agent_hive_mind_desc: 'Kollektivbewusstsein steigert Dok.-Rate +25%',
  agent_boss_hunter: 'Boss-Jäger',
  agent_boss_hunter_desc: 'Spezialisierter Tracker steigert Boss-Schaden +25%',
  agent_faction_liaison: 'Fraktionsverbindung',
  agent_faction_liaison_desc: 'Diplomatische Bande steigern Fraktionsgunst +25%',

  // Epic (5)
  agent_reptilian_elite: 'Reptilianische Elite',
  agent_reptilian_elite_desc: 'Elitekrieger steigert CPS +35%',
  agent_galaxy_commander: 'Galaxie-Kommandant',
  agent_galaxy_commander_desc: 'Galaktische Autorität steigert GC-Gewinn +40%',
  agent_dark_secretary: 'Dunkler Sekretär',
  agent_dark_secretary_desc: 'Schattenbürokrat steigert Prestige-GC +20%',
  agent_omega_operative: 'Omega-Operativ',
  agent_omega_operative_desc: 'Ultimativer Kämpfer steigert Boss-Schaden +50%',
  agent_shapeshifter: 'Gestaltwandler',
  agent_shapeshifter_desc: 'Meister der Formen steigert Tippkraft +40%',

  // Legendary (2)
  agent_the_overlord: 'Der Oberherr',
  agent_the_overlord_desc: 'Oberster Kommandant steigert gesamtes CPS +50%',
  agent_grand_architect: 'Großer Architekt',
  agent_grand_architect_desc: 'Kosmischer Planer beschleunigt Eroberung +60%',

  // Faction system
  faction_status_title: 'Fraktionsstatus',
  faction_favorability: 'Gunst',
  faction_tier: 'Stufe {n}',

  // Faction event popup
  faction_event_help: 'Helfen',
  faction_event_ignore: 'Ignorieren',
  faction_event_timer: '{seconds}s verbleibend',
  faction_event_reward: '+{favor} {faction} Gunst, -{loss} {target} Gunst',
  faction_event_ip_reward: '+{amount} IP Belohnung',
  faction_event_ad_bonus: 'Werbung: +{n} {faction} Gunst',

  // Faction names
  faction_illuminati: 'Illuminaten',
  faction_illuminati_desc: 'Geheime menschliche Herrscher, die im Schatten die Faden ziehen',
  faction_grey: 'Graue Aliens',
  faction_grey_desc: 'Technologie teilende ausserirdische Spezies',
  faction_mib: 'MIB-Widerstand',
  faction_mib_desc: 'Geheime menschliche Organisation gegen ausserirdischen Einfluss',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: 'Eroberungstempo +20%',
  faction_grey_bonus1: 'Tippen +15%',
  faction_grey_bonus2: 'Tippen +20%',
  faction_grey_bonus3: 'Goldener Keks +25%',
  faction_mib_bonus1: 'Boss-Schaden +20%',
  faction_mib_bonus2: 'Offline-Einkommen +15%',
  faction_mib_bonus3: 'Boss-Erscheinen -15%',

  // Event titles and descriptions
  event_illu_decode_title: 'Geheime Abfangaktion',
  event_illu_decode_desc: 'Die Illuminaten fangen geheime Regierungsdateien ab. Beim Entschlusseln helfen?',
  event_illu_stock_title: 'Borsenmanipulation',
  event_illu_stock_desc: 'Die Illuminaten wollen die globalen Borsenmarkte manipulieren. Insiderinformationen liefern?',
  event_illu_surveillance_title: 'Uberwachungsnetzwerk',
  event_illu_surveillance_desc: 'Die Illuminaten bauen ein geheimes Uberwachungsnetzwerk auf. Beim Bau helfen?',
  event_illu_meeting_title: 'Geheimgipfel',
  event_illu_meeting_desc: 'Ein geheimes Illuminaten-Treffen bei einer Versammlung von Weltfuhrern. Sicherheit bieten?',
  event_illu_bribe_title: 'Alien-Diplomatie',
  event_illu_bribe_desc: 'Die Illuminaten wollen einen ausserirdischen Diplomaten bestechen. Das Paket zustellen?',

  event_grey_experiment_title: 'Menschenforschung',
  event_grey_experiment_desc: 'Graue Aliens fuhren Experimente an Menschen durch. Das Labor bewachen?',
  event_grey_mindcontrol_title: 'Gedankenkontrollgerat',
  event_grey_mindcontrol_desc: 'Graue Aliens wollen ein Gedankenkontrollgerat in einer Stadt installieren. Beim Bau helfen?',
  event_grey_crash_title: 'Absturzbergung',
  event_grey_crash_desc: 'Ein Kundschafterschiff der Grauen ist in der Wuste abgesturzt. Bei der Bergung der Besatzung helfen?',
  event_grey_terraform_title: 'Geheime Terraformung',
  event_grey_terraform_desc: 'Graue Aliens terraformen heimlich eine Insel. Ressourcen bereitstellen?',
  event_grey_hack_title: 'Satelliten-Hack',
  event_grey_hack_desc: 'Graue Aliens wollen das Satellitennetzwerk der Erde hacken. Zugangscodes liefern?',

  event_mib_raid_title: 'Alien-Aussenposten-Angriff',
  event_mib_raid_desc: 'Das MIB plant einen Angriff auf einen Alien-Aussenposten. Am Sturm teilnehmen?',
  event_mib_safehouse_title: 'Versteck Entdeckt',
  event_mib_safehouse_desc: 'Das MIB hat ein geheimes Illuminaten-Versteck entdeckt. Beim Angriff helfen?',
  event_mib_weapons_title: 'Waffenentwicklung',
  event_mib_weapons_desc: 'Das MIB entwickelt Anti-Alien-Waffen. Seltene Materialien liefern?',
  event_mib_evacuate_title: 'Zivilevakuierung',
  event_mib_evacuate_desc: 'Das MIB muss Zivilisten aus einer Alien-Angriffszone evakuieren. Helfen?',
  event_mib_expose_title: 'Korruption Aufgedeckt',
  event_mib_expose_desc: 'Das MIB will die Korruption der Illuminaten offentlich machen. Die Dokumente leaken?',

  // Shadow Contact (mid-game ad choices)
  sc_title: 'Schattenkontakt',
  sc_accept: 'Deal Annehmen',
  sc_decline: 'Ablehnen',
  sc_offer_intel: 'Geheimdienstbericht',
  sc_offer_intel_desc: 'Ein Doppelagent bietet geheime Informationen im Wert von {amount} 🛸',
  sc_offer_serum: 'Experimentelles Serum',
  sc_offer_serum_desc: 'Eine Alien-Laborprobe, die die Tippkraft 30 Sekunden lang x10 verstaerkt',
  sc_offer_tech: 'Schwarzmarkt-Technologie',
  sc_offer_tech_desc: 'Gestohlene Alien-Technologie, die das Einkommen 30 Sekunden lang x10 erhoht',
  sc_offer_docs: 'Geheimer Dokumenten-Cache',
  sc_offer_docs_desc: 'Ein verstecktes Lager mit 3 geheimen Dokumenten 📜',
  boss_warning: 'WARNUNG',
  boss_warning_sub: 'Ein mächtiger Feind nähert sich...',
  boss_tutorial_title: 'Bosskampf!',
  boss_tutorial_text: 'Ein Boss ist erschienen! Tippe schnell, um Schaden zu verursachen, bevor die Zeit abläuft.<br><br>Besiege Bosse für <b>IP, Dokumente und Agentenkarten</b>!<br>Sieh eine Werbung für <b>2x Schaden</b>.',
  // === Infiltration Run (generated) ===
  tab_infiltration: "Infiltrate",
  infil_eyebrow: "INFILTRATION OPS",
  infil_title: "Infiltration Run",
  infil_subtitle: "Slip in, climb the ranks, get out clean.",
  infil_tutorial_note: "First run: learn the ropes. Chasing the top rank too hard gets you caught.",
  infil_agent_stats: "Agent Stats",
  infil_highest_career: "Best Career",
  infil_total_runs: "Total Runs",
  infil_total_success: "Successes",
  infil_tradeoff_hint: "Safe = small reward, low rank. Greedy = high detection, high risk. Weigh every choice.",
  infil_start: "Start Infiltration",
  infil_start_tutorial: "Start Tutorial Run",
  infil_cooldown: "Cooldown",
  infil_cancel: "Cancel",
  infil_detection: "Detection",
  infil_step: "Event",
  infil_difficulty: "Diff",
  infil_selecting: "Selecting",
  infil_choice_success: "SUCCESS",
  infil_choice_fail: "FAILED",
  infil_roll: "Roll",
  infil_next: "Next",
  infil_to_extraction: "To Extraction",
  infil_extraction_cat: "FINAL STEP",
  infil_extraction_title: "Extraction",
  infil_extraction_desc: "All events cleared. Slip out now — the lower your detection, the safer.",
  infil_attempt_extraction: "Attempt Extraction",
  infil_final_chance: "Extraction Chance",
  infil_result_success: "INFILTRATION SUCCESS",
  infil_result_fail: "CAUGHT",
  infil_result_success_sub: "You slipped out and secured a cover career.",
  infil_result_fail_sub: "Security caught you. Nothing gained this time.",
  infil_docs: "Docs",
  infil_cleared: "Cleared",
  infil_career_earned: "Career Secured",
  infil_fail_note: "No reward. A short cooldown before the next run.",
  infil_retry_ad: "Watch Ad: Second Chance",
  infil_retry_title: "Second Chance",
  infil_retry_desc: "Watch a short ad to lower your detection and retry the extraction once.",
  infil_retry_confirm: "Watch Ad",
  infil_close: "Close",
  infil_stat_disguise: "Disguise",
  infil_stat_combat: "Combat",
  infil_stat_hacking: "Hacking",
  infil_stat_charisma: "Charisma",
  infil_stat_none: "No Check",
  infil_tag_safe: "SAFE",
  infil_tag_risky: "RISKY",
  infil_tag_aggressive: "ALL-IN",
  infil_career_cleaner: "Cleaner",
  infil_career_guard: "Guard",
  infil_career_clerk: "Clerk",
  infil_career_manager: "Manager",
  infil_career_executive: "Executive",
  infil_career_director: "Director",
  infil_career_warrior: "Warrior",
  infil_career_none: "None",
  infil_ev_patrol_cat: "Infiltration Case / Corporate State",
  infil_ev_patrol_title: "Patrol Approaching",
  infil_ev_patrol_desc: "A security patrol is heading straight for you. How do you react?",
  infil_ch_patrol_a_label: "Wait in the shadows",
  infil_ch_patrol_a_desc: "Hold your breath until they pass. Safe, but you lose time.",
  infil_ch_patrol_b_label: "Greet them as staff",
  infil_ch_patrol_b_desc: "Nod politely in your cover identity and walk past.",
  infil_ch_patrol_c_label: "Take them down",
  infil_ch_patrol_c_desc: "Ambush the patrol and force through. Big reward, big risk.",
  infil_ev_security_check_cat: "Infiltration Case / Corporate State",
  infil_ev_security_check_title: "Security Checkpoint",
  infil_ev_security_check_desc: "A manned checkpoint blocks the corridor ahead.",
  infil_ch_security_check_a_label: "Find a side route",
  infil_ch_security_check_a_desc: "Quietly slip down an adjacent passage.",
  infil_ch_security_check_b_label: "Show forged pass",
  infil_ch_security_check_b_desc: "Present a well-made forged access pass.",
  infil_ch_security_check_c_label: "Hack the scanner",
  infil_ch_security_check_c_desc: "Breach the scanner terminal and kill the alarm.",
  infil_ev_informant_cat: "Infiltration Case / Corporate State",
  infil_ev_informant_title: "Recruit an Informant",
  infil_ev_informant_desc: "An insider might hand over classified files — for a price.",
  infil_ch_informant_a_label: "Take the anonymous tip",
  infil_ch_informant_a_desc: "Check the drop box without making contact.",
  infil_ch_informant_b_label: "Persuade the insider",
  infil_ch_informant_b_desc: "Win over the staffer with smooth talk.",
  infil_ch_informant_c_label: "Strong-arm the files",
  infil_ch_informant_c_desc: "Threaten them into surrendering the data.",
  infil_ev_cctv_cat: "Infiltration Case / Corporate State",
  infil_ev_cctv_title: "Bypass the CCTV",
  infil_ev_cctv_desc: "A ceiling of cameras sweeps the whole hall.",
  infil_ch_cctv_a_label: "Move through blind spots",
  infil_ch_cctv_a_desc: "Creep slowly along the camera blind spots.",
  infil_ch_cctv_b_label: "Loop the feed",
  infil_ch_cctv_b_desc: "Splice a fake loop into the surveillance feed.",
  infil_ch_cctv_c_label: "Smash the cameras",
  infil_ch_cctv_c_desc: "Wreck the cameras and rush past.",
  infil_ev_fake_id_cat: "Infiltration Case / Corporate State",
  infil_ev_fake_id_title: "ID Inspection",
  infil_ev_fake_id_desc: "Guards are checking every ID in a long queue.",
  infil_ch_fake_id_a_label: "Leave the queue",
  infil_ch_fake_id_a_desc: "Quietly drop out and find another way.",
  infil_ch_fake_id_b_label: "Present forged ID",
  infil_ch_fake_id_b_desc: "Pass the checkpoint with a crafted forgery.",
  infil_ch_fake_id_c_label: "Sweet-talk the guard",
  infil_ch_fake_id_c_desc: "Talk your way past with slick charm.",
  infil_ev_parking_cat: "Infiltration Case / Corporate State",
  infil_ev_parking_title: "Underground Parking",
  infil_ev_parking_desc: "The garage is your way in, but a guard patrols it.",
  infil_ch_parking_a_label: "Hide behind vehicles",
  infil_ch_parking_a_desc: "Tuck yourself between parked cars.",
  infil_ch_parking_b_label: "Neutralize the guard",
  infil_ch_parking_b_desc: "Silently subdue the garage guard.",
  infil_ch_parking_c_label: "Pose as valet",
  infil_ch_parking_c_desc: "Steal a valet uniform and stroll in.",
  infil_ev_server_room_cat: "Infiltration Case / Corporate State",
  infil_ev_server_room_title: "Server Room Breach",
  infil_ev_server_room_desc: "The core data sits behind a hardened server-room door.",
  infil_ch_server_room_a_label: "Crawl the vents",
  infil_ch_server_room_a_desc: "Take the narrow vents. Slow but safe.",
  infil_ch_server_room_b_label: "Seize admin access",
  infil_ch_server_room_b_desc: "Hijack admin rights to open the room.",
  infil_ch_server_room_c_label: "Force the door",
  infil_ch_server_room_c_desc: "Rip open the security door and barge in.",
  infil_ev_board_meeting_cat: "Infiltration Case / Corporate State",
  infil_ev_board_meeting_title: "Board Meeting Infiltration",
  infil_ev_board_meeting_desc: "Top executives are trading secrets behind closed doors.",
  infil_ch_board_meeting_a_label: "Eavesdrop from the hall",
  infil_ch_board_meeting_a_desc: "Listen quietly from outside the room.",
  infil_ch_board_meeting_b_label: "Pose as consultant",
  infil_ch_board_meeting_b_desc: "Blend in as an outside consultant.",
  infil_ch_board_meeting_c_label: "Storm the room",
  infil_ch_board_meeting_c_desc: "Raid the room and seize every secret. Warrior play.",
  infil_ev_reporter_cat: "Infiltration Case / Corporate State",
  infil_ev_reporter_title: "Shake the Reporter",
  infil_ev_reporter_desc: "A dogged journalist is tailing your every move.",
  infil_ch_reporter_a_label: "Blend into the crowd",
  infil_ch_reporter_a_desc: "Melt into a busy street to lose the tail.",
  infil_ch_reporter_b_label: "Change disguise",
  infil_ch_reporter_b_desc: "Swap outerwear and reverse direction.",
  infil_ch_reporter_c_label: "Feed false leads",
  infil_ch_reporter_c_desc: "Approach first and plant fake information.",
  infil_ev_party_cat: "Infiltration Case / Corporate State",
  infil_ev_party_title: "Crash the Party",
  infil_ev_party_desc: "A gala hides the people you need to reach.",
  infil_ch_party_a_label: "Carry a waiter tray",
  infil_ch_party_a_desc: "Grab an empty tray and pose as service.",
  infil_ch_party_b_label: "Pose as a guest",
  infil_ch_party_b_desc: "Mingle smoothly as an invited guest.",
  infil_ch_party_c_label: "Enter as a VIP",
  infil_ch_party_c_desc: "Dress as a VIP and stride through the front.",
  infil_ev_drone_cat: "Infiltration Case / Corporate State",
  infil_ev_drone_title: "Drone Surveillance",
  infil_ev_drone_desc: "A surveillance drone sweeps the open yard.",
  infil_ch_drone_a_label: "Wait under cover",
  infil_ch_drone_a_desc: "Hide beneath a structure until it passes.",
  infil_ch_drone_b_label: "Jam the signal",
  infil_ch_drone_b_desc: "Jam its comms and blind the drone.",
  infil_ch_drone_c_label: "Shoot it down",
  infil_ch_drone_c_desc: "Down the drone. Sure, but it leaves traces.",
  infil_ev_guard_shift_cat: "Infiltration Case / Corporate State",
  infil_ev_guard_shift_title: "Guard Shift Change",
  infil_ev_guard_shift_desc: "A shift change opens a brief window in the watch.",
  infil_ch_guard_shift_a_label: "Wait for the swap",
  infil_ch_guard_shift_a_desc: "Wait for the gap and move on the change.",
  infil_ch_guard_shift_b_label: "Pose as relief guard",
  infil_ch_guard_shift_b_desc: "Walk into the post as the relief guard.",
  infil_ch_guard_shift_c_label: "Ambush the guard",
  infil_ch_guard_shift_c_desc: "Jump the guard just before the swap.",
  infil_ev_vault_cat: "Infiltration Case / Corporate State",
  infil_ev_vault_title: "The Secret Vault",
  infil_ev_vault_desc: "A hidden vault holds the crown-jewel documents.",
  infil_ch_vault_a_label: "Skip the vault",
  infil_ch_vault_a_desc: "Leave the vault and grab only your target.",
  infil_ch_vault_b_label: "Crack the e-lock",
  infil_ch_vault_b_desc: "Hack the electronic lock and open it.",
  infil_ch_vault_c_label: "Blow the vault",
  infil_ch_vault_c_desc: "Blast it open and grab everything. Top reward.",
  infil_ev_vaccine_cat: "Infiltration Case / Corporate State",
  infil_ev_vaccine_title: "Vaccination Cover",
  infil_ev_vaccine_desc: "A pop-up clinic is the perfect cover to get inside.",
  infil_ch_vaccine_a_label: "Join the queue",
  infil_ch_vaccine_a_desc: "Line up as an ordinary patient.",
  infil_ch_vaccine_b_label: "Wear a medic gown",
  infil_ch_vaccine_b_desc: "Put on a medic gown and walk inside.",
  infil_ch_vaccine_c_label: "Impersonate the chief",
  infil_ch_vaccine_c_desc: "Pose as the director and dismiss the staff.",
  infil_ev_broadcast_cat: "Infiltration Case / Corporate State",
  infil_ev_broadcast_title: "Broadcast Control Room",
  infil_ev_broadcast_desc: "The station feed could carry your message — or your evidence.",
  infil_ch_broadcast_a_label: "Read the logs",
  infil_ch_broadcast_a_desc: "Quietly review the broadcast logs only.",
  infil_ch_broadcast_b_label: "Intercept the feed",
  infil_ch_broadcast_b_desc: "Hack the feed and siphon the data.",
  infil_ch_broadcast_c_label: "Pose as live director",
  infil_ch_broadcast_c_desc: "Impersonate the live director and take the room.",
  infil_ev_border_cat: "Infiltration Case / Corporate State",
  infil_ev_border_title: "Border Checkpoint",
  infil_ev_border_desc: "A guarded border stands between you and the target.",
  infil_ch_border_a_label: "Take an unwatched trail",
  infil_ch_border_a_desc: "Cross via an unmonitored back trail.",
  infil_ch_border_b_label: "Persuade the officer",
  infil_ch_border_b_desc: "Talk the inspector out of suspicion.",
  infil_ch_border_c_label: "Pose as a diplomat",
  infil_ch_border_c_desc: "Cross under a diplomatic cover identity.",
  infil_ch_border_d_label: "Ram the barrier",
  infil_ch_border_d_desc: "Smash the barrier with a vehicle and floor it.",
} as const;
